import moment from "moment";
import {appUrl} from "../helpers";

window.activeEditorForInsertImage = null;

function displaySource(editor) {
	var html = editor.value()
		.replace(/\<br \/\>/g, "<br />\n")
		.replace(/\<p /g, "\n<p ")
		.replace(/\<div /g, "\n<div ")
		.replace(/\<tr /g, "\n<tr ")
		.replace(/\<td /g, "\n<td ")
		.replace(/\<\/td\>/g, "</td>\n")
		.replace(/\<\/div\>/g, "</div>\n")
		.replace(/\<\/tr\>/g, "</tr>\n")
		.replace(/\<\/table\>/g, "</table>\n")
		.replace(/\<\/p\>/g, "</p>\n");

	var myWindow = $('<div id="wysiwyg-source"><textarea id="view-source-textarea" style="width: 100%; height: 100%">' + html + '</textarea></div>').appendTo("body");

	myWindow.kendoWindow({
		width: '80%',
		height: '80%',
		visible: true,
		modal: true,
		title: 'Editace zdroje',
	});

	var popup = myWindow.data('kendoWindow');
	popup.open().toFront().center().setOptions({
		position: {
			top: 150,
		}
	});

	let $txt = $('#view-source-textarea');
	let cm = CodeMirror.fromTextArea($txt.get(0), {
		lineNumbers: true,
		mode: "htmlmixed",
		lineWrapping: true,
		indentWithTabs: true,
		styleActiveLine: true,
		matchBrackets: true,
	});

	var sourceChanged = false;

	cm.on('change',function(cMirror) {
		sourceChanged = true;
	});

	cm.setSize('100%', '100%');

	popup.bind('close', function (event) {
		kendo.destroy(myWindow);
		if (sourceChanged) {
			k1Confirm('Chcete aktualizovat editor?').then(function () {
				editor.value(cm.getValue());
			});
		}
	});

}

function insertImage(editor) {
	openInModalDialog(appUrl('cms') + '/image/insert-image/default?functionName=wysiwygInsertImage&wysiwyg=1', '80%', 'insert-image-shop');

	window.activeEditorForInsertImage = editor;
	window.storedRange = editor.getRange();
}

export function wysiwygInsertImage(imageData) {
	window.activeEditorForInsertImage.selectRange(window.storedRange);
	window.activeEditorForInsertImage.exec("inserthtml", { value: '<img src="' + imageData.path + '" alt="' + imageData.title + '" title="' + imageData.title + '"/>' });

	return false;
}
window.wysiwygInsertImage = wysiwygInsertImage

let wysiwygTools = [
	{
		name: "k1Undo",
		tooltip: "O krok zpět",
		exec: function (e) {
			var editor = $(e.currentTarget).closest('.k-editor.k-widget').find('.k-raw-content').data('kendoEditor');
			if (typeof editor === 'undefined') {
				editor = $('body').find('.k-widget.k-editor.k-editor-inline.k-state-active').data('kendoEditor');
			}
			editor.exec('undo');
		}
	},
	{
		name: "k1Redo",
		tooltip: "O krok vpřed",
		exec: function (e) {
			var editor = $(e.currentTarget).closest('.k-editor.k-widget').find('.k-raw-content').data('kendoEditor');
			if (typeof editor === 'undefined') {
				editor = $('body').find('.k-widget.k-editor.k-editor-inline.k-state-active').data('kendoEditor');
			}
			editor.exec('redo');
		}
	},
	"bold", "italic", "underline", "strikethrough", "subscript", "superscript",
	"justifyLeft", "justifyCenter", "justifyRight", "justifyFull",
	"insertUnorderedList", "insertOrderedList", "indent", "outdent",
	"createLink", "unlink",
	{
		name: "k1Image",
		tooltip: "Vložit obrázek",
		exec: function (e) {
			var editor = $(e.currentTarget).closest('.k-editor.k-widget').find('.k-raw-content').data('kendoEditor');
			if (typeof editor === 'undefined') {
				editor = $('body').find('.k-widget.k-editor.k-editor-inline.k-state-active').data('kendoEditor');
			}

			insertImage(editor)
		}
	},
	{
		name: "k1UploadImage",
		tooltip: "Vložit obrázek z počítače",
		exec: function (e) {
			var editor = $(e.currentTarget).closest('.k-editor.k-widget').find('.k-raw-content').data('kendoEditor');
			if (typeof editor === 'undefined') {
				editor = $('body').find('.k-widget.k-editor.k-editor-inline.k-state-active').data('kendoEditor');
			}
			editor.exec('insertImage');

			$('.k-filebrowser .k-tiles-arrange').hide(); //hide ordering
			$('.k-filebrowser .k-breadcrumb').hide(); //hide navigation

			let listViewItemsCount = $('.k-filebrowser .k-listview .k-listview-item').length;
			let interval = setInterval(function() {
				let dialog = document.querySelector('.k-filebrowser-dialog');
				if (!dialog || !dialog.offsetParent) {
					clearInterval(interval);
				}
				// set ordering by size
				// little hack - size is not set => images ordered by order value
				var $select = $('.k-filebrowser .k-tiles-arrange select');
				var dropDownList = $select.data('kendoDropDownList');
				if (dropDownList.value() !== 'size') {
					dropDownList.value('size');
					dropDownList.trigger('change');
				}
				// if new image uploaded => reorder again
				let newListViewItemsCount = $('.k-filebrowser .k-listview .k-listview-item').length;
				if (listViewItemsCount !== newListViewItemsCount) {
					dropDownList.value('size');
					dropDownList.trigger('change');
					listViewItemsCount = newListViewItemsCount;
				}
			}, 1000);
		}
	},
	"tableWizard", "createTable",
	"formatting", "cleanFormatting",
	{
		name: "k1Source",
		tooltip: "Zobrazit zdroj",
		exec: function (e) {
			var editor = $(e.currentTarget).closest('.k-editor.k-widget').find('.k-raw-content').data('kendoEditor');
			if (typeof editor === 'undefined') {
				editor = $('body').find('.k-widget.k-editor.k-editor-inline.k-state-active').data('kendoEditor');
			}

			displaySource(editor)
		}
	},
	"copyFormat", "applyFormat",
];

let shortcodes = [
	{
		name: "insertHtml",
		items: [
			{text: 'productById [text]', value: '{productById|000000|text}'},
			{text: 'productById [textový odkaz]', value: '{productById|000000|link}'},
			{text: 'productStockQuantity number [42]', value: '{productStockQuantity|000000|roundDown10}'},
			{text: 'productCountByUrl number [42]', value: '{productCountByUrl|URL}'},
			{text: 'productCountByUrl round DOWN [40]', value: '{productCountByUrl|URL|roundDown10}'},
			{text: 'productCountByUrl round UP [50]', value: '{productCountByUrl|URL|roundUp10}'},
			{text: 'countdown full [x dní x hodin x minut x sekund]', value: '{countdown|' + tomorrow() + '|full}'},
			{text: 'countdown simple [x d. x h. x m. x s.]', value: '{countdown|' + tomorrow() + '|simple}'},
			{text: 'countdown numeric [hh:mm:ss]', value: '{countdown|' + tomorrow() + '|numeric}'},
			{text: 'lastDayOfMonth [dd.mm.yyyy]', value: '{lastDayOfMonth|' + today('YYYY-MM') + '|numeric}'},
			{text: 'firstDayOfMonth [dd.mm.yyyy]', value: '{firstDayOfMonth|' + today('YYYY-MM') + '|numeric}'},
			{text: 'today [dd.mm.yyyy]', value: '{today}'},
			{text: 'aktuální rok [yyyy]', value: '{year}'},
			{text: 'jednotky [ks|lokalizovano]', value: '{quantityUnit}'},
		]
	}
];

let orderShortcodes = [
  {
    name: "insertHtml",
    items: [
      {text: 'Číslo objednávky', value: '[[order-number]]'},
      {text: 'Stav objednávky', value: '[[order-status]]'},
      {text: 'Zboží v objednávce', value: '[[order-list]]'},
      {text: 'Info o zákazníkovi', value: '[[customer]]'},
      {text: 'Jméno zákazníka', value: '[[customer-name]]'},
      {text: 'Název obchodu', value: '[[shop-name]]'},
      {text: 'Url obchodu', value: '[[shop-url]]'},
      {text: 'Částka k úhradě', value: '[[amount-to-pay]]'},
      {text: 'Typ platby', value: '[[payment-type]]'},
      {text: 'Bankovní účet', value: '[[bank-account]]'},
      {text: 'Porfolio z objednávky', value: '[[portfolio]]'},
      {text: 'Číslo zásilky', value: '[[parcel-number]]'},
      {text: 'Url zásilky', value: '[[parcel-url]]'},
    ]
  }
];

window.wysiwygTools = wysiwygTools
window.shortcodes = shortcodes
window.orderShortcodes = orderShortcodes

function tomorrow(format) {
	return moment().add(1, 'days').format('YYYY-MM-DD HH:mm');
}

function today(format) {
	return moment().format(format);
}

export function handleWysiwyg(selector) {
	if (typeof selector === 'object') {
		var $cont = selector.find('[wysiwyg]:not(.k-content)');
	} else {
		var $cont = $(selector + ' [wysiwyg]:not(.k-content)');
	}

	$cont.each(function (idx) {
		let $wysiwygTextarea = $(this);

		var tools = window.wysiwygTools;
		if (typeof $wysiwygTextarea.attr('enable-shortcodes') !== 'undefined') {
			tools = tools.concat(window.shortcodes);
		}

    if (typeof $wysiwygTextarea.attr('enable-order-shortcodes') !== 'undefined') {
      tools = tools.concat(window.orderShortcodes);
    }

    if (typeof $wysiwygTextarea.attr('data-custom-block') !== 'undefined') {

      tools = tools.concat([
        {
          name: "insertHtml",
          items: JSON.parse($wysiwygTextarea.attr('data-custom-block'))
        }
      ]);
    }

		$wysiwygTextarea.kendoEditor({
			encoded: false,
			serialization: {
				entities: false
			},
			imageBrowser: {
				transport: {
					read: appUrl('cms') + '/image/server-image/server-image-list',
					uploadUrl: appUrl('cms') + '/image/server-image/server-image-upload',
					imageUrl: '/k1.cms/media/images/upload/{0}'
				},
				messages: {
					orderBySize: "Newest"
				},
			},
			pasteCleanup: {
				span: true,
				css: true,
				msAllFormatting: true,
			},
			resizable: {
				min: 600
			},
			tools: tools
		});
	});

}
